module.exports = __webpack_public_path__ + "static/media/renBTC-ETH.e95efd71.png";